import script from "./FileTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTransfer.vue?vue&type=script&setup=true&lang=js"

import "./FileTransfer.vue?vue&type=style&index=0&id=53ea278f&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ea278f"]])

export default __exports__